import { FC } from 'react';
import { Control, FieldValues, useWatch } from 'react-hook-form';
import { Box, useThemeValue } from '@altermaind/web/ui';
import { Form } from '@/_shared/components/Form';
import { convertSizeToNumber } from '@/_shared/helpers';
import { useEmployeeCompleteQuiz } from '../hook/useEmployeeCompleteQuiz';

type Props = {
  currentStep: ReturnType<typeof useEmployeeCompleteQuiz>['currentStep'];
  control: Control<FieldValues>;
};
export const SingleChoiceAnswer: FC<Props> = ({ currentStep, control }) => {
  const gapXS = convertSizeToNumber(`${useThemeValue('sizes', 'xs')}`) || 16;
  const value = useWatch({
    control,
    name: `${currentStep?.nextQuestion?.question.id}` || 'singleChoiceAnswer',
  });

  return (
    <Box style={{ cursor: 'pointer' }}>
      <Form.FormRadio
        // @ts-ignore
        control={control}
        name={`${currentStep?.nextQuestion?.question.id}` || 'singleChoiceAnswer'}
        items={
          currentStep?.nextQuestion?.question.options
            ?.map((option, index) => ({
              label: option.text || '',
              value: `${option.id}` || '',
              index,
              selected: value === `${option.id}`,
            }))
            .sort(() => Math.random() - 1) || []
        }
        radioItemAlign='vertical'
        wrapperProps={{
          style: { gap: gapXS },
          display: 'flex',
        }}
        containerRadioProps={{
          px: 's',
          py: 'xs',
          bg: 'grey/dark/background',
          borderRadius: 's',
        }}
        checkedColor='white'
        containerSelectedRadioOverrideProps={{
          bg: 'primary',
        }}
        isTotalClickable
        disabled={currentStep?.stepAlreadySubmitted}
      />
    </Box>
  );
};
